import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeader, Typography } from 'web-library';

const ImportantSection = () => {
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader title={t('accessArrangement->>Notes.ImportantHeader')} />
      <Typography>{t('accessArrangement->>Notes.RelevantInformation')}</Typography>
    </>
  );
};

export default ImportantSection;
